import Repository from "@/services/repository";

export default {
  createExport(studyId, type) {
    return Repository.post(`/a/${studyId}/keywords_exports.json?type=${type}`, {
      type,
    }).then((response) => response.data);
  },

  createSemanticalExport(studyId, keywordIds, type, device) {
    return Repository.post(
      `/a/${studyId}/keywords_semantic_exports.json?type=${type}`,
      {
        keywordIds,
        device
      }
    ).then((response) => response.data);
  },
};
